import Vue from "vue";
import Vuex from "vuex";
import { $api, setProp, deleteProp } from "bh-mod";
Vue.use(Vuex);

export default {
	state: {
		searchFilter: "",
		getStarted: false,
		allSettings: {},
		multipleImages: false,
		activePhoneNumbers: [],
		aiCallAgents: [],
		aiLLMModels: [],
		aiVoices: [],
		knowledgeBaseStatusColor: {
			queued: 'blue',
			processing: 'orange',
			completed: 'green',
			partial_failed: 'purple',
			failed: 'red',
			Pending: 'gray',
		},
		knowledgeBaseStatusLabel: {
			queued: 'Queued',
			processing: 'Processing',
			completed: 'Completed',
			partial_failed: 'Partial Failed',
			failed: 'Failed',
			pending: 'Pending',
		},
		knowledgeBaseList: [],
		leadTags: [],
		senders: [],
		sendingDomains: [],
		emailTemplates: [],
		users: [],
		forms: [],
		opportunityStages: [],
		filterDrawer: {
			visible: false,
			filter: {
				agents: [],
				direction: ['any'],
				status: ['any'],
				userSentiment: ['any'],
				fromNumber: [],
				startedAt: null,
				endedAt: null,
				duration: null,
			},
		},
		allowedMimeTypes: [
			"application/pdf",           // PDF documents
			"text/plain",                // Plain text
			"application/json",          // JSON
			"text/html",                 // HTML
			"application/xml",           // XML
			"text/xml",                  // XML text
			"application/rtf",           // Rich Text Format
			"application/msword",        // Word .doc
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",  // Word .docx
			"application/vnd.ms-excel",  // Excel .xls
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",        // Excel .xlsx
			"text/csv"                   // CSV (treated as text)
		]
	},
	mutations: {
		UPDATE_SEARCH(state, data) {
			state.searchFilter = data;
		},
		SET_APPDATA(state, data) {
			if (!data) data = {};
		},
		SET_SETTINGS(state, data) {
			let temp = data;

			temp.userApp = data.userApp || { options: { seenIntro: false, ai: [] } };

			temp.app = data.app || { options: {} };
			temp.app.options = temp.app.options || {};

			const defaultLeadScorePoints = {
				AIChatConversationStart: 3,
				AIChatMessage: 1,
				AIChatHighIntent: 8,
			};

			const defaultAiQualification = {
				enabled: true,
				sources: {
					chatSummaryEnabled: true,
					callAnalyzedEnabled: true,
				},
				weights: {
					budgetFit: 0.35,
					productFit: 0.30,
					timingReadiness: 0.15,
					intentStrength: 0.20,
				},
				aiQualificationCountThreshold: 70,
			};

			temp.app.options.leadScorePoints = {
				...defaultLeadScorePoints,
				...(temp.app.options.leadScorePoints || {}),
			};
			temp.app.options.leadScoreMaxMessagePointsPerConversation =
				temp.app.options.leadScoreMaxMessagePointsPerConversation ?? 5;

			temp.app.options.aiQualification = {
				...defaultAiQualification,
				...(temp.app.options.aiQualification || {}),
			}

			state.allSettings = temp;
		},
		UPDATE_APP_OPTIONS_SETTINGS: (state, data) => {
			state.allSettings.app.options = { ...state.allSettings.app.options, ...data };
		},
		GET_STARTED: (state) => {
			state.getStarted = true;
		},
		SET_PROP: (state, { where, what, del = false, update = false }) => {
			if (del) return deleteProp(state, where);
			if (typeof where === "string") where = where.split(".");
			state.newStoreTime = Date.now();
			setProp(state, where, what);
		},

		SET_MULTIPLE_IMAGES(state, data) {
			state.multipleImages = data
		},
		SET_AI_CALL_AGENTS: (state, data) => {
			state.aiCallAgents = data;
		},
		SET_ACTIVE_PHONE_NUMBERS: (state, data) => {
			state.activePhoneNumbers = data
		},

		SET_AI_VOICES: (state, data) => {
			state.aiVoices = data;
		},
		SET_AI_LLM_MODELS: (state, data) => {
			state.aiLLMModels = data;
		},

		SET_KNOWLEDGE_BASE_LIST: (state, data) => {
			state.knowledgeBaseList = data;
		},
		SET_LEAD_TAGS: (state, data) => {
			state.leadTags = data || [];
		},
		SET_SENDERS: (state, data) => {
			state.senders = data;
		},
		SET_SENDING_DOMAINS: (state, data) => {
			state.sendingDomains = data || [];
		},
		SET_EMAIL_TEMPLATE(state, data) {
			state.emailTemplates = data || [];
		},
		SET_USERS: (state, data) => {
			state.users = data.map(d => d.user) || [];
		},
		SET_FORMS: (state, data) => {
			state.forms = data || [];
		},
		SET_OPPORTUNITY_STAGES: (state, data) => {
			state.opportunityStages = data;
		},
		OPEN_FILTER(state) {
			state.filterDrawer.visible = true;
		},
		CLOSE_FILTER(state) {
			state.filterDrawer.visible = false;
		},
		UPDATE_FILTER(state, data) {
			state.filterDrawer.filter = data;
		},
		RESET_DEFAULT_FILTER(state) {
			state.filterDrawer.filter = {
				agents: [],
				direction: ['any'],
				status: ['any'],
				userSentiment: ['any'],
				fromNumber: [],
				startedAt: null,
				endedAt: null,
				duration: null,
			};
		},
	},
	actions: {
		SET_APPDATA: ({ commit, dispatch, rootGetters }, data) => {
			commit("SET_APPDATA", data)

			if (rootGetters.isAIProORAdvancedEnabled) {
				if (rootGetters.isAIAdvanceAddOn) {
					dispatch('FETCH_AI_VOICES');
					// LLM model selection is currently hidden for end users; backend uses default values
					// dispatch('FETCH_AI_LLM_MODELS');
				}
				dispatch('FETCH_ACTIVE_PHONE_NUMBERS');
			}

			dispatch('FETCH_LEAD_TAGS');
			dispatch('FETCH_SENDERS');
			dispatch('FETCH_EMAIL_TEMPLATE');
			dispatch('FETCH_USERS');
			dispatch('FETCH_FORMS');
			dispatch('FETCH_CRM_APP_SETTINGS');
		},
		FETCH_AI_CALL_AGENTS: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/ai-agents/:instance?capability_type=call&active=true`);
				commit('SET_AI_CALL_AGENTS', data)
			} catch (error) {
				console.error('Error occurred while fetching ai call agent list', error)
			}
		},
		FETCH_AI_VOICES: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/instances/:instance/calling-voices`);
				const voices = (data.voices || []).filter(voice => voice.voice_id);
				commit('SET_AI_VOICES', voices)
			} catch (error) {
				console.error(`An error occurred while fetching AI voices.`, error);
			}
		},
		FETCH_AI_LLM_MODELS: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/instances/:instance/calling-llms`);
				commit('SET_AI_LLM_MODELS', data.llms || [])
			} catch (error) {
				console.error(`An error occurred while fetching AI LLM models.`, error);
			}
		},
		FETCH_ACTIVE_PHONE_NUMBERS: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/sending-phone-numbers/:instance`);
				commit('SET_ACTIVE_PHONE_NUMBERS', data)
			} catch (error) {
				console.error(`An error occurred while fetching instance phone number.`, error);
			}
		},

		FETCH_KNOWLEDGE_BASE_LIST: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/ai-agent-knowledge-bases/:instance?_limit=-1`);
				commit('SET_KNOWLEDGE_BASE_LIST', data)
			} catch (error) {
				console.error(`An error occurred while fetching knowledge base list.`, error);
			}
		},

		async FETCH_LEAD_TAGS({ commit }) {
			try {
				const { data } = await $api.get(`/tags/:instance?type=contacts`);
				commit('SET_LEAD_TAGS', data)
			} catch (error) {
				console.error('Error occurred while fetching lead tags', error)
			}
		},

		async FETCH_SENDERS({ commit }) {
			try {
				const { data } = await $api.get(`/senders/:instance?active=true`);
				commit('SET_SENDERS', data)
			} catch (error) {
				console.error('Error occurred while fetching sender list', error)
			}
		},

		async FETCH_SENDING_DOMAINS({ commit, state }) {
			if (state.sendingDomains && state.sendingDomains.length) {
				return state.sendingDomains;
			}
			try {
				const { data } = await $api.get(`/sending-domains/:instance`);
				commit('SET_SENDING_DOMAINS', data || []);
				return data || [];
			} catch (error) {
				console.error('Error occurred while fetching sending domains', error);
				return [];
			}
		},

		async FETCH_EMAIL_TEMPLATE({ commit }) {
			try {
				const { data } = await $api.get(`/projects/:instance?type=email&default=true&_sort=updatedAt:DESC`);
				commit('SET_EMAIL_TEMPLATE', data)
			} catch (error) {
				console.error('Error occurred while fetching email template list', error)
			}
		},

		async FETCH_USERS({ commit }) {
			try {
				const { data } = await $api.get(`instances/:instance/users`);
				commit('SET_USERS', data.users)
			} catch (error) {
				console.error('Error occurred while fetching user list', error)
			}
		},

		async FETCH_FORMS({ commit }) {
			try {
				const { data } = await $api.get(`/forms/:instance?_limit=-1`);
				commit('SET_FORMS', data)
			} catch (error) {
				console.error('Error occurred while fetching form list', error)
			}
		},

		async FETCH_CRM_APP_SETTINGS({ commit }) {
			try {
				const { data } = await $api.get(`/settings/:instance/contacts`);

				const opportunityStages = data?.options?.stages?.list?.length ? data.options.stages.list : [
					{ name: 'In Transaction', color: 'var(--orange)', id: 'transaction' },
					{ name: 'Won', color: 'var(--teal)', id: 'won' },
					{ name: 'Lost', color: 'var(--danger)', id: 'lost' },
				];

				commit('SET_OPPORTUNITY_STAGES', opportunityStages)
			} catch (error) {
				console.error('Error occurred while fetching CRM app settings', error)
			}
		},
	},
	getters: {
		isSMSActive(state) {
			return state.allSettings?.instance?.options?.activeFeatures?.sms ?? false;
		},

		appliedFilterCount: state => {
			let count = 0
			Object.keys(state.filterDrawer.filter).forEach(key => {
				const filter = state.filterDrawer.filter[key]
				if (Array.isArray(filter) && (filter.length > 1 || (filter.length == 1 && filter[0] !== 'any'))) {
					count += 1
				} else if (filter !== null && filter !== undefined && ['startedAt', 'endedAt', 'duration'].includes(key)) {
					count += 1
				}
			})
			return count
		}
	},
};
